/* 幸子ジュエリー · animaciones de confianza
   - [data-cj="talla"]   talla universal: la abertura de la pulsera se cierra o se abre un poco según la muñeca
   - [data-cj="macizo"]  "cobre" bañado frente a cobre macizo, por fuera, con el uso y por dentro
   - [data-cj="patina"]  pátina → limón y sal → como el primer día
   data-variant="compact" quita el titular; data-variant="mini" es una franja baja (figura a la izquierda, texto a la derecha)
   que se mueve sola, para la ficha y los advertoriales.
   Sin dependencias. Solo se anima con el componente en pantalla; con "reducir movimiento" queda fijo en el estado que lo explica. */
(function () {
  'use strict';
  if (window.__cjConfianza) return;
  window.__cjConfianza = true;

  var NS = 'http://www.w3.org/2000/svg';
  var REDUCE = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var PI = Math.PI, TAU = PI * 2, DEG = PI / 180;
  var uid = 0;

  /* ---------- utilidades ---------- */
  function S(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function set(e, attrs) { for (var k in attrs) e.setAttribute(k, attrs[k]); }
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ease(t) { t = clamp(t, 0, 1); return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function easeOut(t) { t = clamp(t, 0, 1); return 1 - Math.pow(1 - t, 3); }
  function prog(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
  function pt(cx, cy, a, b, th) { return [cx + a * Math.cos(th), cy + b * Math.sin(th)]; }
  function f2(n) { return n.toFixed(2); }
  /* arco de elipse en sentido horario de pantalla, de t1 a t2 (radianes, 0 = derecha, PI/2 = abajo) */
  function arc(cx, cy, a, b, t1, t2) {
    if (t2 - t1 < 0.002) t2 = t1 + 0.002;
    var p1 = pt(cx, cy, a, b, t1), p2 = pt(cx, cy, a, b, t2), big = (t2 - t1) > PI ? 1 : 0;
    return 'M' + f2(p1[0]) + ' ' + f2(p1[1]) + 'A' + f2(a) + ' ' + f2(b) + ' 0 ' + big + ' 1 ' + f2(p2[0]) + ' ' + f2(p2[1]);
  }
  function tangentDeg(a, b, th) { return Math.atan2(b * Math.cos(th), -a * Math.sin(th)) / DEG; }
  function blurFilter(defs, id, sd) {
    var f = S('filter', { id: id, x: '-30%', y: '-30%', width: '160%', height: '160%' }, defs);
    S('feGaussianBlur', { stdDeviation: sd }, f);
    return 'url(#' + id + ')';
  }
  function grad(defs, id, stops, attrs) {
    var g = S('linearGradient', Object.assign({ id: id }, attrs || { x1: 0, y1: 0, x2: 0, y2: 1 }), defs);
    stops.forEach(function (s) { S('stop', { offset: s[0], 'stop-color': s[1], 'stop-opacity': s[2] == null ? 1 : s[2] }, g); });
    return 'url(#' + id + ')';
  }
  function rgrad(defs, id, stops, attrs) {
    var g = S('radialGradient', Object.assign({ id: id }, attrs || {}), defs);
    stops.forEach(function (s) { S('stop', { offset: s[0], 'stop-color': s[1], 'stop-opacity': s[2] == null ? 1 : s[2] }, g); });
    return 'url(#' + id + ')';
  }
  function star(parent, r, fill) {
    var k = r * .22;
    return S('path', { d: 'M0 ' + -r + 'L' + k + ' ' + -k + 'L' + r + ' 0L' + k + ' ' + k + 'L0 ' + r + 'L' + -k + ' ' + k + 'L' + -r + ' 0L' + -k + ' ' + -k + 'Z', fill: fill }, parent);
  }

  /* ---------- paletas de metal ---------- */
  var COBRE = { band: [[0, '#F6CCA2'], [.3, '#D9965F'], [.58, '#AE6532'], [.82, '#86461F'], [1, '#5E2E14']], cap: ['#F6CFA6', '#8A4520'], hi: 'rgba(255,244,232,.78)', rim: 'rgba(255,206,164,.42)' };
  var PATINA = { band: [[0, '#7C5D45'], [.4, '#5E432F'], [.75, '#463123'], [1, '#2C1F16']], cap: ['#7F604A', '#33241A'], hi: 'rgba(214,186,156,.16)', rim: 'rgba(170,140,110,.14)' };

  /* ---------- pulsera abierta vista de frente ----------
     Banda con degradado de metal, filo interior y exterior, brillo, martillado a mano y remates redondeados. */
  function Cuff(parent, defs, pal, box) {
    var id = 'cjc' + (++uid);
    var band = grad(defs, id + 'b', pal.band, { x1: 0, y1: box[0], x2: 0, y2: box[1], gradientUnits: 'userSpaceOnUse' });
    var cap = rgrad(defs, id + 'c', [[0, pal.cap[0]], [1, pal.cap[1]]], { cx: .36, cy: .3, r: .8 });
    var blur = blurFilter(defs, id + 'f', 2.2);
    var g = S('g', null, parent);
    var shadow = S('path', { fill: 'none', stroke: 'rgba(42,29,20,.26)', 'stroke-linecap': 'round', filter: blur }, g);
    var body = S('path', { fill: 'none', stroke: band, 'stroke-linecap': 'round' }, g);
    var inner = S('path', { fill: 'none', stroke: 'rgba(60,26,10,.45)', 'stroke-width': .9 }, g);
    var outer = S('path', { fill: 'none', stroke: 'rgba(255,232,210,.32)', 'stroke-width': .8 }, g);
    var c1 = S('circle', { fill: band }, g), c2 = S('circle', { fill: band }, g);
    var rimL = S('path', { fill: 'none', stroke: pal.rim || 'rgba(255,214,178,.38)', 'stroke-linecap': 'round' }, g);
    var hi = S('path', { fill: 'none', stroke: pal.hi, 'stroke-linecap': 'round' }, g);
    var hi2 = S('path', { fill: 'none', stroke: pal.hi, 'stroke-linecap': 'round', opacity: .55 }, g);
    var d1 = S('circle', { fill: pal.hi, opacity: .7 }, g), d2 = S('circle', { fill: pal.hi, opacity: .7 }, g);
    var self = {
      g: g, geo: null,
      update: function (cx, cy, a, b, th, gap) {
        var t1 = PI / 2 + gap / 2, t2 = PI / 2 - gap / 2 + TAU, d = arc(cx, cy, a, b, t1, t2);
        self.geo = { cx: cx, cy: cy, a: a, b: b, th: th, t1: t1, t2: t2, d: d };
        set(shadow, { d: d, 'stroke-width': th, transform: 'translate(0 ' + f2(th * .32) + ')' });
        set(body, { d: d, 'stroke-width': th });
        set(inner, { d: arc(cx, cy, a - th / 2 + .6, b - th / 2 + .6, t1 + .02, t2 - .02) });
        set(outer, { d: arc(cx, cy, a + th / 2 - .7, b + th / 2 - .7, t1 + .02, t2 - .02) });
        // brillo principal arriba a la izquierda, uno corto a la derecha y luz de borde abajo
        set(hi, { d: arc(cx, cy, a - th * .16, b - th * .16, 204 * DEG, 248 * DEG), 'stroke-width': f2(th * .14) });
        set(hi2, { d: arc(cx, cy, a - th * .16, b - th * .16, 292 * DEG, 304 * DEG), 'stroke-width': f2(th * .1) });
        set(rimL, { d: arc(cx, cy, a + th * .22, b + th * .22, 18 * DEG, 64 * DEG), 'stroke-width': f2(th * .11) });
        var p1 = pt(cx, cy, a, b, t1), p2 = pt(cx, cy, a, b, t2), r = th * .56;
        set(c1, { cx: f2(p1[0]), cy: f2(p1[1]), r: f2(r) });
        set(c2, { cx: f2(p2[0]), cy: f2(p2[1]), r: f2(r) });
        set(d1, { cx: f2(p1[0] - r * .3), cy: f2(p1[1] - r * .35), r: f2(r * .22) });
        set(d2, { cx: f2(p2[0] - r * .3), cy: f2(p2[1] - r * .35), r: f2(r * .22) });
        self.ends = [p1, p2]; self.capR = r;
      }
    };
    return self;
  }

  /* franja mini: pasos como tres segmentos que se llenan */
  function segsHTML(n) { var h = '<span class="cjc-segs">'; for (var i = 0; i < n; i++) h += '<i><b></b></i>'; return h + '</span>'; }
  /* versión media: los 3 pasos a la vista (número, nombre y barra que se llena), como unas historias */
  function stepsHTML(names) {
    return '<div class="cjc-st">' + names.map(function (s, i) {
      return '<button type="button" class="cjc-sti" data-i="' + i + '"><span class="cjc-stb"><b></b></span><span class="cjc-stn">' + (i + 1) + '</span><span class="cjc-stl">' + s + '</span></button>';
    }).join('') + '</div>';
  }
  function fade(c, ct) {
    if (!c.innerHTML) { c.innerHTML = ct; return; }
    c.style.opacity = 0;
    setTimeout(function () { c.innerHTML = ct; c.style.opacity = 1; }, 180);
  }
  function fillSegs(root, DUR, tt) {
    var bs = root.querySelectorAll('.cjc-segs b, .cjc-stb b'), base = 0;
    for (var i = 0; i < bs.length; i++) { bs[i].style.transform = 'scaleX(' + clamp((tt - base) / DUR[i], 0, 1).toFixed(4) + ')'; base += DUR[i]; }
  }

  /* ---------- estilos (una sola vez) ---------- */
  function css() {
    if (document.getElementById('cjc-css')) return;
    var st = document.createElement('style');
    st.id = 'cjc-css';
    st.textContent = [
      '.cjc{--ink:#2A1D14;--ink2:#4A3B2E;--mut:#85766A;--line:#E3D6C6;--cu:#94502A;font-family:"Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif;color:var(--ink);text-align:center;max-width:520px;margin:0 auto;-webkit-tap-highlight-color:transparent}',
      '.cjc *{box-sizing:border-box}',
      '.cjc-k{margin:0 0 8px!important;font:400 10.5px/1.4 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:.24em!important;text-transform:uppercase;color:var(--cu)!important}',
      '.cjc-h{margin:0 0 12px!important;font:700 25px/1.16 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:-.005em!important;color:var(--ink)!important;text-wrap:balance}',
      '.cjc-h em{font-style:italic;font-weight:400;color:var(--cu)}',
      '.cjc-fig{display:block!important;position:relative}',
      '.cjc-svg{display:block;width:100%;height:auto;overflow:visible}',
      '.cjc-p{margin:10px auto 0!important;max-width:34ch;font:400 15px/1.55 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--ink2)!important;text-wrap:pretty}',
      '.cjc-p strong{color:var(--ink);font-weight:700}',
      '.cjc-n{margin:8px auto 0!important;max-width:34ch;font:italic 400 14px/1.45 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--mut)!important}',
      /* deslizador de la muñeca */
      '.cjc-ctrl{display:flex;align-items:center;gap:12px;max-width:290px;margin:2px auto 0;font:400 10px/1 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif;letter-spacing:.2em;text-transform:uppercase;color:var(--mut)}',
      '.cjc-range{-webkit-appearance:none;appearance:none;flex:1;min-width:0;height:34px;margin:0!important;padding:0!important;border:0!important;background:transparent!important;box-shadow:none!important;cursor:grab;--p:50%}',
      '.cjc-range:active{cursor:grabbing}',
      '.cjc-range::-webkit-slider-runnable-track{height:2px;border-radius:2px;background:linear-gradient(90deg,#94502A var(--p),#E3D6C6 var(--p))}',
      '.cjc-range::-moz-range-track{height:2px;border-radius:2px;background:#E3D6C6}',
      '.cjc-range::-moz-range-progress{height:2px;border-radius:2px;background:#94502A}',
      '.cjc-range::-webkit-slider-thumb{-webkit-appearance:none;width:14px;height:24px;margin-top:-11px;border-radius:3px;background:linear-gradient(180deg,#F1C59A,#C07A45 52%,#7A3E1C);border:2px solid #FFFDF8;box-shadow:0 2px 7px rgba(42,29,20,.32)}',
      '.cjc-range::-moz-range-thumb{width:12px;height:22px;border-radius:3px;background:linear-gradient(180deg,#F1C59A,#C07A45 52%,#7A3E1C);border:2px solid #FFFDF8;box-shadow:0 2px 7px rgba(42,29,20,.32)}',
      '.cjc-range:focus{outline:none}',
      '.cjc-range:focus-visible::-webkit-slider-thumb{box-shadow:0 0 0 4px rgba(148,80,42,.25),0 2px 7px rgba(42,29,20,.32)}',
      '.cjc-live{margin:4px 0 0!important;min-height:1.45em;font:italic 400 16px/1.4 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--cu)!important;transition:opacity .3s}',
      /* pasos editoriales (sin píldoras): número en cursiva, etiqueta en versalitas y raíl de cobre debajo */
      '.cjc-steps{display:flex!important;position:relative;max-width:420px;margin:14px auto 0}',
      '.cjc-step{-webkit-appearance:none;appearance:none;flex:1;min-width:0;min-height:0!important;margin:0!important;padding:6px 4px 11px!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;font:400 9px/1.3 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:.11em!important;text-transform:uppercase;color:var(--mut)!important;cursor:pointer;transition:color .35s}',
      '.cjc-step b{display:block;margin-bottom:4px;font:italic 400 18px/1 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif;letter-spacing:0;text-transform:none;color:inherit;transition:color .35s}',
      '.cjc-step.is-on{color:var(--ink)!important}',
      '.cjc-step.is-on b{color:var(--cu)}',
      '.cjc-rail{position:absolute;left:0;right:0;bottom:0;height:1px;background:var(--line);display:block!important}',
      '.cjc-rail i{position:absolute;left:0;top:-.5px;height:2px;width:100%;background:var(--cu);transform-origin:left;transform:scaleX(0);display:block}',
      '.cjc-cap{margin:12px auto 0!important;max-width:33ch;min-height:3em;font:400 15px/1.5 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--ink2)!important;transition:opacity .35s;text-wrap:pretty}',
      '.cjc-cap strong{color:var(--ink)}',
      /* dos columnas para bañado / macizo, separadas por un filo */
      '.cjc-cols{display:grid!important;grid-template-columns:1fr 1fr;position:relative}',
      '.cjc-cols::before{content:"";position:absolute;left:50%;top:4px;bottom:4px;width:1px;background:var(--line)}',
      '.cjc-col{padding:0 4px;display:block!important}',
      '.cjc-lab{margin:0 0 2px!important;font:700 9.5px/1.3 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:.2em!important;text-transform:uppercase;color:var(--cu)!important}',
      '.cjc-col.is-fake .cjc-lab{color:var(--mut)!important;font-weight:400!important}',
      '.cjc-cc{margin:2px auto 0!important;max-width:19ch;min-height:2.9em;font:400 14px/1.4 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--ink2)!important;transition:opacity .35s}',
      '.cjc-compact .cjc-k{margin-bottom:2px!important}',
      '.cjc-line{display:flex!important;align-items:center;gap:10px;margin:2px 0 12px;font:400 14.5px/1.35 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif;color:#4A3B2E}',
      '.cjc-line-i{flex:none;display:block!important;width:34px;height:26px}',
      '.cjc-line-i svg{display:block;width:34px;height:26px;overflow:visible}',
      '.cjc-line-t{flex:1;min-width:0}',
      '.cjc-line-t strong{color:#2A1D14;font-weight:700}',
      '.cjc-line-a{flex:none;font-size:13.5px;color:#94502A!important;text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px}',
      '.cjc-compact .cjc-p{font-size:14px!important}',
      /* franja mini: figura a la izquierda, texto a la derecha */
      /* versión media: figura arriba y texto debajo a todo el ancho, sin renglones que salten */
      '.cjc-mini{display:block!important;text-align:center;max-width:420px}',
      '.cjc-mini>.cjc-fig{width:168px;margin:0 auto 6px}',
      '.cjc-mini.cjc-patina>.cjc-fig{width:178px}',
      '.cjc-mini.cjc-macizo>.cjc-fig{width:100%;max-width:280px;display:grid!important;grid-template-columns:1fr 1fr;gap:16px}',
      '.cjc-mini .cjc-col{padding:0}',
      '.cjc-mini .cjc-lab{margin:0 0 2px!important;font-size:9px!important;letter-spacing:.16em!important;text-align:center}',
      '.cjc-mt{display:block!important;min-width:0;max-width:340px;margin:0 auto}',
      '.cjc-mk{margin:0 0 4px!important;font:400 9.5px/1.4 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:.2em!important;text-transform:uppercase;color:var(--cu)!important}',
      '.cjc-mc{margin:0!important;min-height:2.9em;font:400 14.5px/1.45 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;color:var(--ink2)!important;transition:opacity .3s;text-wrap:balance}',
      '.cjc-mc strong{color:var(--ink)}',
      '.cjc-mini,.cjc-mini p{text-align:center!important}',
      '.cjc-mini .cjc-mt{margin-left:auto!important;margin-right:auto!important}',
      '.cjc-mini .cjc-mc{font-size:15.5px!important;max-width:340px;margin:0 auto!important}',
      '.cjc-mini.cjc-talla .cjc-mc{font-size:14.5px!important}',
      '@media (max-width:380px){.cjc-mt2{font-size:20px!important}.cjc-mini.cjc-talla .cjc-mc{font-size:13.6px!important}}',
      '.cjc-mt2{margin:0 auto 10px!important;max-width:none;white-space:nowrap;text-align:center!important;font:700 22px/1.2 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:0!important;color:var(--ink)!important;text-wrap:balance}',
      '.cjc-mt2 em{font-style:italic;font-weight:400;color:var(--cu)}',
      '.cjc-st{display:flex!important;justify-content:center;gap:12px;max-width:330px;margin:4px auto 12px!important;padding:0!important}',
      '.cjc-sti{-webkit-appearance:none;appearance:none;flex:1 1 0;min-width:0;min-height:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;cursor:pointer;text-align:center!important;color:var(--mut)!important;font:400 9.5px/1.3 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif!important;letter-spacing:.14em!important;text-transform:uppercase;transition:color .35s}',
      '.cjc-stb{display:block!important;height:2px;background:var(--line);position:relative;overflow:hidden;margin:0 0 9px}',
      '.cjc-stb b{position:absolute;left:0;top:0;width:100%;height:100%;background:var(--cu);transform-origin:left;transform:scaleX(0);display:block}',
      '.cjc-stn{display:block!important;margin:0 0 4px;font:italic 400 21px/1 "Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif;letter-spacing:0;text-transform:none;color:inherit;transition:color .35s}',
      '.cjc-stl{display:block!important;min-height:2.6em}',
      '.cjc-sti.is-done{color:var(--ink2)!important}',
      '.cjc-sti.is-on{color:var(--ink)!important}',
      '.cjc-sti.is-on .cjc-stn{color:var(--cu)}',
      '.cjc-mini .cjc-live{margin:0 0 3px!important;min-height:1.4em;font-size:17px!important;line-height:1.4!important;white-space:nowrap}',
      '.cjc-segs{display:flex!important;gap:4px;max-width:240px;margin:10px auto 0}',
      '.cjc-segs i{flex:1;height:2px;background:var(--line);position:relative;overflow:hidden;display:block}',
      '.cjc-segs i b{position:absolute;left:0;top:0;width:100%;height:100%;background:var(--cu);transform-origin:left;transform:scaleX(0);display:block}',
      '@media (min-width:750px){.cjc-h{font-size:30px!important}.cjc-mini>.cjc-fig{width:190px}.cjc-mini.cjc-macizo>.cjc-fig{width:100%;max-width:320px}}'
    ].join('');
    document.head.appendChild(st);
  }

  /* ====================================================================
     1 · TALLA UNIVERSAL
     ==================================================================== */
  function Talla(root) {
    var variant = root.getAttribute('data-variant'), compact = variant === 'compact', mini = variant === 'mini';
    root.classList.add('cjc', 'cjc-talla');
    if (compact) root.classList.add('cjc-compact');
    if (mini) {
      root.classList.add('cjc-mini');
      root.innerHTML = '<div class="cjc-fig"></div><div class="cjc-mt">' +
        '<p class="cjc-live"></p><p class="cjc-mc">しっかりと<wbr>した<wbr>無垢の<wbr>銅。<wbr>一度、<wbr>手で<wbr>押して<wbr>合わせれば、<strong><wbr>形が<wbr>崩れる<wbr>ことは<wbr>ありません。</strong></p></div>';
    } else root.innerHTML =
      (compact ? '<p class="cjc-k">フリーサイズ・<wbr>手首に<wbr>合わせて<wbr>調整</p>'
               : '<p class="cjc-k">フリーサイズ</p><h3 class="cjc-h"><em>あなたの</em><wbr>手首に<wbr>合わせて</h3>') +
      '<div class="cjc-fig"></div>' +
      '<div class="cjc-ctrl"><span>細い</span><input class="cjc-range" type="range" min="0" max="1000" value="500" aria-label="手首の太さ（細い〜太い）"><span>太い</span></div>' +
      '<p class="cjc-live"></p>' +
      '<p class="cjc-p">下の<wbr>すき間を<wbr>手で<wbr>押して<wbr>少し<wbr>閉じたり開いたりすれば、<wbr>ぴったりの<wbr>サイズに<wbr>なります。<strong><wbr>しっかりと<wbr>した<wbr>無垢の<wbr>銅なので、<wbr>一度<wbr>合わせれば<wbr>形が<wbr>崩れません。</strong></p>' +
      (compact ? '' : '<p class="cjc-n">一度<wbr>合わせれば、<wbr>そのまま<wbr>ずっと<wbr>寄り<wbr>添います。</p>');

    var W = 340, H = 200, CX = 170, CY = 88, TH = 9;
    var svg = S('svg', { viewBox: mini ? '96 26 148 140' : '0 0 ' + W + ' ' + H, class: 'cjc-svg', role: 'img', 'aria-label': '手首にはめたバングル。細い手首ではすき間を少し閉じ、太い手首では少し開きます' }, root.querySelector('.cjc-fig'));
    var defs = S('defs', null, svg), id = 'cjt' + (++uid);
    var soft = blurFilter(defs, id + 's', 4), soft2 = blurFilter(defs, id + 'q', 2.6);
    var skin = rgrad(defs, id + 'k', [[0, '#F5E0CB'], [.55, '#EAC9A9'], [1, '#D6A883']], { cx: .42, cy: .36, r: .72 });
    var clip = S('clipPath', { id: id + 'c' }, defs), clipE = S('ellipse', null, clip);

    var ground = S('ellipse', { fill: 'rgba(42,29,20,.11)', filter: soft }, svg);
    var wrist = S('ellipse', { fill: skin }, svg);
    var rim = S('g', { 'clip-path': 'url(#' + id + 'c)' }, svg), rimE = S('ellipse', { fill: 'none', stroke: 'rgba(140,82,48,.30)', 'stroke-width': 9, filter: soft2 }, rim);
    var label = S('text', { 'text-anchor': 'middle', fill: '#A27D62', 'font-family': '"Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif', 'font-size': 14 }, svg);
    label.textContent = '手首';
    var cuff = Cuff(svg, defs, COBRE, [CY - 70, CY + 70]);

    // presión en los remates: dos ondas y una flecha fina en cada lado
    var gest = S('g', { opacity: 0 }, svg), ripples = [], arrows = [];
    for (var i = 0; i < 2; i++) {
      ripples.push(S('circle', { fill: 'none', stroke: '#94502A', 'stroke-width': 1.1 }, gest));
      arrows.push(S('path', { fill: 'none', stroke: '#94502A', 'stroke-width': 1.6, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, gest));
    }
    // cota de la abertura
    var dim = S('g', null, svg);
    var dimL = S('path', { fill: 'none', stroke: '#94502A', 'stroke-width': 1 }, dim);
    var dimT = S('text', { 'text-anchor': 'middle', fill: '#94502A', 'font-family': '"Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif', 'font-size': 9.5, 'letter-spacing': 1 }, dim);
    dimT.textContent = mini ? '' : 'すき間';

    var range = root.querySelector('.cjc-range'), live = root.querySelector('.cjc-live');
    var t = .5, tPrev = .5, moveAmt = 0, lastLive = '', wave = 0;

    function draw(dt) {
      var wa = 52 + 9 * t, wb = 40 + 6.2 * t;
      var a = wa - .6 + TH / 2, b = wb - .6 + TH / 2;
      var gap = (38 + 18 * t) * DEG;                       // abertura real de pulsera; entre fina y ancha cambia poco
      set(ground, { cx: CX, cy: CY + b + TH / 2 + 22, rx: f2(a * .95), ry: 5 });
      set(wrist, { cx: CX, cy: CY, rx: f2(wa), ry: f2(wb) });
      set(clipE, { cx: CX, cy: CY, rx: f2(wa), ry: f2(wb) });
      set(rimE, { cx: CX, cy: CY, rx: f2(wa), ry: f2(wb) });
      set(label, { x: CX, y: CY + 5 });
      cuff.update(CX, CY, a, b, TH, gap);
      var p1 = cuff.ends[0], p2 = cuff.ends[1], r = cuff.capR;
      // cota
      var y = Math.max(p1[1], p2[1]) + r + 12, x1 = p1[0] + r + 1.5, x2 = p2[0] - r - 1.5;
      set(dimL, { d: 'M' + f2(x1) + ' ' + f2(y) + 'H' + f2(x2) + 'M' + f2(x1) + ' ' + f2(y - 4) + 'V' + f2(y + 4) + 'M' + f2(x2) + ' ' + f2(y - 4) + 'V' + f2(y + 4) });
      set(dimT, { x: CX, y: f2(y + 15) });
      // gesto: aparece mientras la pulsera se mueve; la flecha apunta hacia donde va el remate
      var v = dt > 0 ? (t - tPrev) / dt : 0;
      moveAmt = lerp(moveAmt, Math.abs(v) > .03 ? 1 : 0, clamp(dt * 7, 0, 1));
      var dir = v > 0 ? 1 : -1;                              // 1 = se abre, -1 = se cierra
      wave = (wave + dt * 1.6) % 1;
      set(gest, { opacity: f2(moveAmt) });
      [p1, p2].forEach(function (p, k) {
        var side = k === 0 ? -1 : 1, rr = r + 1.5 + wave * 8;
        set(ripples[k], { cx: f2(p[0]), cy: f2(p[1]), r: f2(rr), opacity: f2((1 - wave) * .7) });
        // flecha horizontal por fuera de cada remate: hacia dentro al cerrar, hacia fuera al abrir
        var x0 = p[0] + side * (r + 7), x1 = p[0] + side * (r + 19), ay = p[1];
        var tipX = dir > 0 ? x1 : x0, tailX = dir > 0 ? x0 : x1, hd = tipX > tailX ? -1 : 1;
        set(arrows[k], { d: 'M' + f2(tailX) + ' ' + f2(ay) + 'H' + f2(tipX) + 'M' + f2(tipX + hd * 4) + ' ' + f2(ay - 3.6) + 'L' + f2(tipX) + ' ' + f2(ay) + 'L' + f2(tipX + hd * 4) + ' ' + f2(ay + 3.6) });
      });
      if (range) { range.value = Math.round(t * 1000); range.style.setProperty('--p', (t * 100).toFixed(1) + '%'); }
      var txt = mini ? (t < .34 ? '細い手首：少し閉じる' : t > .66 ? '太い手首：少し開く' : '標準：ほぼそのまま')
                     : (t < .34 ? '細い手首なら、少し閉じます' : t > .66 ? '太い手首なら、少し開きます' : '標準の手首なら、ほとんど調整はいりません');
      if (txt !== lastLive) { live.textContent = txt; lastLive = txt; }
      tPrev = t;
    }

    // vaivén automático entre fina y ancha, con pausa en cada extremo; se detiene al tocar
    var seq = { from: .5, to: 1, start: 0, dur: 1.6, hold: .9 }, holdUntil = 0, user = false;
    function next(now) { seq = { from: t, to: t < .5 ? 1 : 0, start: now, dur: 2.5, hold: 1.0 }; }
    if (range) {
      range.addEventListener('input', function () { user = true; holdUntil = performance.now() + 6000; t = range.value / 1000; });
      ['pointerdown', 'touchstart'].forEach(function (ev) { range.addEventListener(ev, function () { user = true; holdUntil = performance.now() + 6000; }, { passive: true }); });
    }

    var last = 0;
    return {
      root: root,
      start: function (now) { last = now; seq.start = now; },
      tick: function (now) {
        var dt = Math.min(.05, (now - last) / 1000); last = now;
        if (user && now > holdUntil) { user = false; next(now); }
        if (!user) {
          var k = (now - seq.start) / 1000;
          if (k < seq.dur) t = lerp(seq.from, seq.to, ease(k / seq.dur));
          else { t = seq.to; if (k > seq.dur + seq.hold) next(now); }
        }
        draw(dt);
      },
      still: function () { t = .5; draw(0); }
    };
  }

  /* ====================================================================
     2 · "COBRE" BAÑADO FRENTE A COBRE MACIZO
     ==================================================================== */
  function Macizo(root) {
    var variant = root.getAttribute('data-variant'), compact = variant === 'compact', mini = variant === 'mini';
    root.classList.add('cjc', 'cjc-macizo');
    if (compact) root.classList.add('cjc-compact');
    var STEPS = ['新品の<wbr>とき', '<wbr>使ううちに<wbr>', '断面を<wbr>見ると<wbr>'];
    var MINI = [
      '買ったばかりの<wbr>ときは、<strong><wbr>どちらも<wbr>同じように<wbr>輝きます。</strong>',
      '<wbr>使ううちに<wbr>メッキははがれます。<strong><wbr>無垢の<wbr>銅は、<wbr>色が<wbr>深まるだけです。</strong>',
      '断面を<wbr>見ると、<wbr>片方は<wbr>鉄や<wbr>真鍮。<strong><wbr>もう<wbr>片方は、<wbr>芯まで<wbr>銅です。</strong>'
    ];
    var CAPS = [
      ['新品は輝いている。', '新品は輝いている。'],
      ['使うとメッキがはがれる。', '使うと色が深まる。'],
      ['中身は鉄や真鍮。', '中身も銅。']
    ];
    if (mini) {
      root.classList.add('cjc-mini');
      root.innerHTML = '<div class="cjc-fig">' +
          '<div class="cjc-col is-fake"><p class="cjc-lab">銅メッキ</p><div class="cjc-fig"></div></div>' +
          '<div class="cjc-col is-real"><p class="cjc-lab">無垢の<wbr>銅</p><div class="cjc-fig"></div></div>' +
        '</div><div class="cjc-mt">' + stepsHTML(STEPS) + '<p class="cjc-mc"></p></div>';
      root.insertAdjacentHTML('afterbegin', '<p class="cjc-mt2">メッキか無垢か、<em>3ステップ</em>で</p>');
    } else root.innerHTML =
      (compact ? '' : '<p class="cjc-k">断面</p><h3 class="cjc-h">銅メッキ<em>か</em>、<wbr>無垢の<wbr>銅か</h3>') +
      '<div class="cjc-cols">' +
        '<div class="cjc-col is-fake"><p class="cjc-lab">銅メッキ</p><div class="cjc-fig"></div><p class="cjc-cc"></p></div>' +
        '<div class="cjc-col is-real"><p class="cjc-lab">無垢の<wbr>銅</p><div class="cjc-fig"></div><p class="cjc-cc"></p></div>' +
      '</div>' +
      '<div class="cjc-steps">' + STEPS.map(function (s, i) { return '<button type="button" class="cjc-step" data-i="' + i + '"><b>' + (i + 1) + '</b>' + s + '</button>'; }).join('') + '<span class="cjc-rail"><i></i></span></div>' +
      '<p class="cjc-cap">本物の<wbr>銅は、<wbr>芯まで銅。<strong><wbr>だから、はがれる<wbr>ことがありません。</strong></p>';

    var cols = [].slice.call(root.querySelectorAll('.cjc-col'));
    var ccs = cols.map(function (c) { return c.querySelector('.cjc-cc'); });
    var steps = [].slice.call(root.querySelectorAll('.cjc-step, .cjc-sti')), rail = root.querySelector('.cjc-rail i');
    var mc = root.querySelector('.cjc-mc');

    function Panel(fig, fake) {
      var svg = S('svg', { viewBox: '0 0 160 190', class: 'cjc-svg', role: 'img', 'aria-label': fake ? '銅メッキのブレスレット：使ううちにメッキがはがれ、中身は鉄や真鍮' : '無垢の銅のブレスレット：使ううちに色が深まり、中身も銅' }, fig);
      var defs = S('defs', null, svg), id = 'cjm' + (++uid);
      var CX = 80, CY = 60, A = 44, B = 40, TH = 13, GAP = 36 * DEG;
      var soft = blurFilter(defs, id + 's', 3);
      S('ellipse', { cx: CX, cy: CY + B + 22, rx: 40, ry: 4, fill: 'rgba(42,29,20,.10)', filter: soft }, svg);
      var cuff = Cuff(svg, defs, COBRE, [CY - 52, CY + 52]);
      cuff.update(CX, CY, A, B, TH, GAP);
      var G = cuff.geo;
      // con el uso: el bañado se gasta desde los remates y en roces; el macizo se oscurece un poco (pátina)
      var core = grad(defs, id + 'g', [[0, '#C4C0B6'], [.5, '#97938A'], [1, '#6E6B64']], { x1: 0, y1: CY - 52, x2: 0, y2: CY + 52, gradientUnits: 'userSpaceOnUse' });
      var wear = S('g', { opacity: 0 }, svg), wearA = [], scuffs = [];
      if (fake) {
        for (var i = 0; i < 2; i++) wearA.push(S('path', { fill: 'none', stroke: core, 'stroke-width': TH - 2.4 }, wear));
        wearA.push(S('circle', { fill: core }, wear)); wearA.push(S('circle', { fill: core }, wear));
        [[210, 8], [262, 6], [318, 9], [355, 5]].forEach(function (s) {
          scuffs.push({ p: S('path', { fill: 'none', stroke: core, 'stroke-width': TH - 5, 'stroke-linecap': 'round' }, wear), c: s[0] * DEG, w: s[1] * DEG });
        });
      } else {
        wearA.push(S('path', { d: G.d, fill: 'none', stroke: 'rgba(70,40,22,.55)', 'stroke-width': TH, 'stroke-linecap': 'round' }, wear));
      }
      // corte: marca en la banda y línea de cota hasta la sección ampliada
      var cut = S('g', { opacity: 0 }, svg);
      var pc = pt(CX, CY, A, B, 0);
      S('path', { d: 'M' + f2(pc[0] - TH / 2 - 3) + ' ' + f2(pc[1]) + 'H' + f2(pc[0] + TH / 2 + 3), stroke: '#2A1D14', 'stroke-width': 1.2 }, cut);
      S('path', { d: 'M' + f2(pc[0] + TH / 2 + 3) + ' ' + f2(pc[1]) + 'C' + f2(pc[0] + 16) + ' ' + f2(pc[1] + 30) + ' 138 116 136 130', fill: 'none', stroke: '#85766A', 'stroke-width': .9, 'stroke-dasharray': '2.5 2.5' }, cut);
      // sección ampliada de la banda
      var SX = 24, SY = 132, SW = 112, SH = 30;
      var sec = S('g', null, cut);
      var copperFill = grad(defs, id + 'k', [[0, '#F0BC8C'], [.45, '#C27C47'], [1, '#78401E']]);
      if (fake) {
        S('rect', { x: SX, y: SY, width: SW, height: SH, rx: 6, fill: '#C27C47' }, sec);                       // baño
        S('rect', { x: SX + 3, y: SY + 3, width: SW - 6, height: SH - 6, rx: 4, fill: core }, sec);          // núcleo
        var lt = S('text', { x: 80, y: SY + 19.5, 'text-anchor': 'middle', fill: '#FBF6EE', 'font-family': '"Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif', 'font-size': 9.5, 'letter-spacing': 1.2 }, sec); lt.textContent = '鉄・真鍮';
      } else {
        S('rect', { x: SX, y: SY, width: SW, height: SH, rx: 6, fill: copperFill }, sec);
        S('rect', { x: SX + 4, y: SY + 2.2, width: SW - 8, height: 1.4, rx: .7, fill: 'rgba(255,238,220,.6)' }, sec);
        var lt2 = S('text', { x: 80, y: SY + 19.5, 'text-anchor': 'middle', fill: '#FFF1E2', 'font-family': '"Noto Serif JP","Hiragino Mincho ProN","Yu Mincho",YuMincho,serif', 'font-size': 9.5, 'letter-spacing': 1.2 }, sec); lt2.textContent = '銅';
      }
      // la lima pasa por el canto: en el bañado se lleva el baño; en el macizo deja cobre recién pulido
      var filed = S('rect', { x: SX, y: SY, width: 0, height: 3.2, rx: 1.4, fill: fake ? core : 'rgba(255,226,190,.95)' }, sec);
      var file = S('g', { opacity: 0 }, svg);
      S('rect', { x: -15, y: -4.5, width: 30, height: 9, rx: 1.5, fill: '#5E6166' }, file);
      for (var h = -12; h <= 12; h += 3) S('path', { d: 'M' + h + ' -4.5l2.2 9', stroke: '#8D9095', 'stroke-width': .7 }, file);
      S('rect', { x: 15, y: -3.2, width: 16, height: 6.4, rx: 3, fill: '#8A5A3B' }, file);
      var filings = [];
      for (var q = 0; q < 14; q++) filings.push({ e: S('rect', { width: 1.8, height: 1.2, fill: fake ? '#9A968D' : '#D99A62', opacity: 0 }, svg), x: 0, y: 0, vx: 0, vy: 0, life: 0 });
      var emit = 0;

      return {
        draw: function (ph, u, dt) {
          // ph: 0 nueva, 1 con el uso, 2 por dentro; u: progreso dentro de la fase
          var w = ph === 0 ? 0 : ph === 1 ? easeOut(u) : 1;
          if (fake) {
            var ww = w * 34 * DEG;
            set(wearA[0], { d: arc(G.cx, G.cy, G.a, G.b, G.t1, G.t1 + ww + .01) });
            set(wearA[1], { d: arc(G.cx, G.cy, G.a, G.b, G.t2 - ww - .01, G.t2) });
            set(wearA[2], { cx: f2(cuff.ends[0][0]), cy: f2(cuff.ends[0][1]), r: f2(cuff.capR * .82 * Math.min(1, w * 2)) });
            set(wearA[3], { cx: f2(cuff.ends[1][0]), cy: f2(cuff.ends[1][1]), r: f2(cuff.capR * .82 * Math.min(1, w * 2)) });
            scuffs.forEach(function (s, i) { var k = clamp(w * 1.6 - i * .15, 0, 1); set(s.p, { d: arc(G.cx, G.cy, G.a, G.b, s.c - s.w * k / 2, s.c + s.w * k / 2 + .001), opacity: f2(k) }); });
            set(wear, { opacity: f2(Math.min(1, w * 3)) });
          } else set(wear, { opacity: f2(w * .55) });
          // sección + lima
          var cv = ph === 2 ? easeOut(u * 3) : 0;
          set(cut, { opacity: f2(cv), transform: 'translate(0 ' + f2((1 - cv) * 6) + ')' });
          var fx = ph === 2 ? lerp(SX - 8, SX + SW + 6, ease(prog(u, .25, .8))) : SX - 8;
          var fon = ph === 2 ? Math.min(prog(u, .18, .28), 1 - prog(u, .85, .95)) : 0;
          set(file, { opacity: f2(fon), transform: 'translate(' + f2(fx) + ' ' + (SY - 4) + ') rotate(-7)' });
          set(filed, { width: f2(clamp(fx - SX, 0, SW)) });
          if (ph === 2 && fon > .5 && fx > SX && fx < SX + SW) {
            emit += dt * 32;
            while (emit > 1) { emit--; var f = filings.find(function (p) { return p.life <= 0; }); if (f) { f.x = fx - 6; f.y = SY - 1; f.vx = -8 - Math.random() * 22; f.vy = -10 - Math.random() * 18; f.life = 1; } }
          }
          filings.forEach(function (p) {
            if (p.life <= 0) { set(p.e, { opacity: 0 }); return; }
            p.life -= dt * 1.5; p.vy += 140 * dt; p.x += p.vx * dt; p.y += p.vy * dt;
            set(p.e, { x: f2(p.x), y: f2(p.y), opacity: f2(clamp(p.life, 0, 1)) });
          });
        }
      };
    }
    var panels = cols.map(function (c, i) { return Panel(c.querySelector('.cjc-fig'), i === 0); });

    var DUR = [1.8, 2.8, 4.2], TOTAL = DUR[0] + DUR[1] + DUR[2];
    var t0 = 0, last = 0, curPh = -1, jumpTo = null;
    steps.forEach(function (b) { b.addEventListener('click', function () { jumpTo = +b.getAttribute('data-i'); }); });
    function at(tt, dt) {
      var ph = tt < DUR[0] ? 0 : tt < DUR[0] + DUR[1] ? 1 : 2;
      var base = ph === 0 ? 0 : ph === 1 ? DUR[0] : DUR[0] + DUR[1], u = (tt - base) / DUR[ph];
      panels.forEach(function (p) { p.draw(ph, u, dt); });
      if (ph !== curPh) {
        curPh = ph;
        steps.forEach(function (b, i) { b.classList.toggle('is-on', i === ph); b.classList.toggle('is-done', i < ph); });
        ccs.forEach(function (c, i) { if (c) c.textContent = CAPS[ph][i]; });
        if (mini) fade(mc, MINI[ph]);
      }
      if (rail) rail.style.transform = 'scaleX(' + (tt / TOTAL).toFixed(4) + ')';
      if (mini) fillSegs(root, DUR, tt);
    }
    return {
      root: root,
      start: function (now) { t0 = now; last = now; },
      tick: function (now) {
        var dt = Math.min(.05, (now - last) / 1000); last = now;
        if (jumpTo != null) { t0 = now - (jumpTo === 0 ? 0 : jumpTo === 1 ? DUR[0] : DUR[0] + DUR[1]) * 1000; jumpTo = null; }
        var tt = (now - t0) / 1000;
        if (tt > TOTAL + 1.2) { t0 = now; tt = 0; }
        at(Math.min(tt, TOTAL - .001), dt);
      },
      still: function () { at(TOTAL - .001, 0); }
    };
  }

  /* ====================================================================
     3 · PÁTINA → LIMÓN Y SAL → COMO EL PRIMER DÍA
     ==================================================================== */
  function Patina(root) {
    var variant = root.getAttribute('data-variant'), compact = variant === 'compact', mini = variant === 'mini';
    root.classList.add('cjc', 'cjc-patina');
    if (compact) root.classList.add('cjc-compact');
    var STEPS = ['く<wbr>すんだ<wbr>色', 'レモンと<wbr>塩', '買った<wbr>日の<wbr>輝き'];
    var MINI = [
      '時間が<wbr>たつと<wbr>色が<wbr>深まり、く<wbr>すんできます。<strong><wbr>それが<wbr>本物の<wbr>銅である<wbr>証です。</strong>',
      'レモン汁を<wbr>少しと、<wbr>塩を<wbr>ひとつまみ。<strong><wbr>やさしく<wbr>こすります。</strong>',
      'すすいで<wbr>拭けば<wbr>完了。<strong><wbr>台所に<wbr>ある<wbr>もので、2分です。</strong>'
    ];
    var CAPS = [
      '純銅は<wbr>生きている<wbr>金属。<wbr>時間が<wbr>たつと<wbr>色が<wbr>深まり、く<wbr>すんできます。<strong><wbr>それが<wbr>本物の<wbr>証です。</strong>',
      'レモン汁を<wbr>少しと、<wbr>塩を<wbr>ひとつまみ。<strong><wbr>やさしく<wbr>こすります。</strong>',
      '<wbr>ぬるめの<wbr>お湯ですすいで、<wbr>水気を<wbr>拭き取ります。<strong><wbr>台所に<wbr>ある<wbr>もので、2分です。</strong>'
    ];
    if (mini) {
      root.classList.add('cjc-mini');
      root.innerHTML = '<p class="cjc-mt2"><em>3ステップ</em>で輝きがよみがえる</p><div class="cjc-fig"></div><div class="cjc-mt">' + stepsHTML(STEPS) + '<p class="cjc-mc"></p></div>';
    } else root.innerHTML =
      (compact ? '' : '<p class="cjc-k">銅の<wbr>お手入れ</p><h3 class="cjc-h">いつまでも<em><wbr>買った<wbr>日の<wbr>輝き</em>を</h3>') +
      '<div class="cjc-fig"></div>' +
      '<div class="cjc-steps">' + STEPS.map(function (s, i) { return '<button type="button" class="cjc-step" data-i="' + i + '"><b>' + (i + 1) + '</b>' + s + '</button>'; }).join('') + '<span class="cjc-rail"><i></i></span></div>' +
      '<p class="cjc-cap"></p>';

    var W = 340, H = 214, CX = 170, CY = 100, A = 80, B = 72, TH = 19, GAP = 34 * DEG;
    var svg = S('svg', { viewBox: mini ? '58 4 224 214' : '0 0 ' + W + ' ' + H, class: 'cjc-svg', role: 'img', 'aria-label': 'くすんだ銅のブレスレットが、レモンと塩でこすると輝きを取り戻す様子' }, root.querySelector('.cjc-fig'));
    var defs = S('defs', null, svg), id = 'cjp' + (++uid);
    var soft = blurFilter(defs, id + 's', 4.5), soft2 = blurFilter(defs, id + 'v', 2.4);
    S('ellipse', { cx: CX, cy: CY + B + TH / 2 + 20, rx: 82, ry: 6, fill: 'rgba(42,29,20,.12)', filter: soft }, svg);

    var old = Cuff(svg, defs, PATINA, [CY - 82, CY + 82]); old.update(CX, CY, A, B, TH, GAP);
    var G = old.geo;
    // verdín en los huecos del martillado
    var verd = S('g', { filter: soft2 }, svg);
    [[205, .5], [228, -.4], [262, .3], [300, -.5], [331, .4], [12, -.3], [45, .45], [150, -.35], [118, .3]].forEach(function (v, i) {
      var th = v[0] * DEG, p = pt(CX, CY, A + TH * v[1] * .5, B + TH * v[1] * .5, th);
      S('ellipse', { cx: f2(p[0]), cy: f2(p[1]), rx: 5.5 + (i % 3) * 1.6, ry: 3.2, fill: i % 2 ? '#7FA088' : '#6B8D77', opacity: .82, transform: 'rotate(' + f2(tangentDeg(A, B, th)) + ' ' + f2(p[0]) + ' ' + f2(p[1]) + ')' }, verd);
    });
    // la pulsera limpia, descubierta por donde pasa el limón
    var mask = S('mask', { id: id + 'm', maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: W, height: H }, defs);
    var maskP = S('path', { fill: 'none', stroke: '#fff', 'stroke-width': TH + 14, 'stroke-linecap': 'round' }, mask);
    var maskC1 = S('circle', { fill: '#fff', r: 0 }, mask), maskC2 = S('circle', { fill: '#fff', r: 0 }, mask);
    var cleanG = S('g', { mask: 'url(#' + id + 'm)' }, svg);
    var fresh = Cuff(cleanG, defs, COBRE, [CY - 82, CY + 82]); fresh.update(CX, CY, A, B, TH, GAP);
    // destello que recorre la banda al final
    var glint = S('path', { d: arc(CX, CY, A - TH * .12, B - TH * .12, 192 * DEG, 352 * DEG), fill: 'none', stroke: 'rgba(255,246,234,.95)', 'stroke-width': 3, 'stroke-linecap': 'round', pathLength: 1, 'stroke-dasharray': '.1 1.2', 'stroke-dashoffset': .1, opacity: 0 }, svg);
    var sparks = [[214, 1], [276, 1.25], [334, .9], [28, 1.1], [150, .85]].map(function (s) {
      var p = pt(CX, CY, A + TH * .25, B + TH * .25, s[0] * DEG);
      var g = S('g', { transform: 'translate(' + f2(p[0]) + ' ' + f2(p[1]) + ') scale(0)' }, svg);
      S('circle', { r: 7 * s[1], fill: 'rgba(255,240,220,.55)', filter: soft2 }, g);
      star(g, 8 * s[1], '#FFF8EE');
      return { g: g, x: p[0], y: p[1], s: s[1] };
    });
    // sal
    var salt = [];
    for (var i = 0; i < 18; i++) {
      var th = (200 + i * 8.2 + (i % 3) * 2) * DEG, p = pt(CX, CY, A + TH * .2, B + TH * .2, th);
      salt.push({ e: S('rect', { width: 2.6, height: 2.6, rx: .4, fill: '#FFFFFF', stroke: 'rgba(42,29,20,.18)', 'stroke-width': .4, opacity: 0 }, svg), x: p[0] + ((i * 37) % 9) - 4, y: p[1] - 2, th: th, d: (i % 6) * .05, rot: (i * 47) % 90 });
    }
    // medio limón visto de frente
    var lemon = S('g', { opacity: 0 }, svg);
    S('ellipse', { cx: 2, cy: 25, rx: 20, ry: 4, fill: 'rgba(42,29,20,.18)', filter: soft2 }, lemon);
    S('circle', { r: 23, fill: '#E7B12E' }, lemon);
    S('circle', { r: 21.2, fill: '#F2C94A' }, lemon);
    S('circle', { r: 19.4, fill: '#FFF4CF' }, lemon);
    S('circle', { r: 17.6, fill: '#F6D861' }, lemon);
    for (var s = 0; s < 9; s++) { var an = s / 9 * TAU; S('path', { d: 'M0 0L' + f2(Math.cos(an) * 17.2) + ' ' + f2(Math.sin(an) * 17.2), stroke: '#FFF1BE', 'stroke-width': 1.4, 'stroke-linecap': 'round' }, lemon); }
    S('circle', { r: 3.2, fill: '#FFF4CF' }, lemon);
    S('ellipse', { cx: -7, cy: -8, rx: 7, ry: 3.4, fill: 'rgba(255,255,255,.35)', transform: 'rotate(-30 -7 -8)' }, lemon);

    var steps = [].slice.call(root.querySelectorAll('.cjc-step, .cjc-sti')), rail = root.querySelector('.cjc-rail i'), cap = root.querySelector('.cjc-cap');
    var mc = root.querySelector('.cjc-mc');
    var DUR = [3.0, 4.0, 2.8], TOTAL = DUR[0] + DUR[1] + DUR[2];
    var t0 = 0, last = 0, curPh = -1, jumpTo = null, firstLap = true;
    steps.forEach(function (b) { b.addEventListener('click', function () { jumpTo = +b.getAttribute('data-i'); }); });

    function at(tt) {
      var ph = tt < DUR[0] ? 0 : tt < DUR[0] + DUR[1] ? 1 : 2;
      var base = ph === 0 ? 0 : ph === 1 ? DUR[0] : DUR[0] + DUR[1], u = (tt - base) / DUR[ph];
      // limón: recorre la banda de un remate al otro frotando adelante y atrás
      var span = G.t2 - G.t1, clean = 0;
      if (ph === 1) {
        var r = prog(u, .2, .95), th = G.t1 + span * ease(r) + Math.sin(u * 46) * .07 * (r > 0 && r < 1 ? 1 : 0);
        clean = ease(r);
        var lp = pt(CX, CY, A, B, th);
        set(lemon, { opacity: f2(Math.min(prog(u, .1, .22), 1 - prog(u, .93, 1))), transform: 'translate(' + f2(lp[0]) + ' ' + f2(lp[1] - 6) + ') rotate(' + f2(Math.sin(u * 46) * 8 - 12) + ')' });
      } else { set(lemon, { opacity: 0 }); clean = ph === 2 ? 1 : 0; }
      // paso 1 desde la segunda vuelta: la pulsera limpia se va oscureciendo (con el tiempo coge pátina)
      var age = ph === 0 && !firstLap ? ease(prog(u, .05, .55)) : 1;
      if (ph === 0 && !firstLap) clean = 1;
      cleanG.style.opacity = (ph === 0 ? 1 - age : 1).toFixed(3);
      set(maskP, { d: clean > 0 ? arc(CX, CY, A, B, G.t1, G.t1 + span * clean) : 'M0 0', opacity: clean > 0 ? 1 : 0 });
      var e1 = old.ends[0], e2 = old.ends[1];
      set(maskC1, { cx: f2(e1[0]), cy: f2(e1[1]), r: clean > 0 ? TH : 0 });
      set(maskC2, { cx: f2(e2[0]), cy: f2(e2[1]), r: clean > .985 ? TH : 0 });
      set(verd, { opacity: f2(ph === 0 ? age : 1 - clean) });
      // sal: cae sobre la banda al empezar y desaparece cuando pasa el limón
      salt.forEach(function (g) {
        var fall = ph === 1 ? easeOut(prog(u, g.d, g.d + .22)) : ph === 2 ? 1 : 0;
        var gone = (ph === 1 && clean > (g.th - G.t1) / span + .02) || ph === 2;
        set(g.e, { x: f2(g.x), y: f2(g.y - (1 - fall) * 46), opacity: f2(gone ? 0 : fall > 0 ? Math.min(1, fall * 3) : 0), transform: 'rotate(' + g.rot + ' ' + f2(g.x + 1.3) + ' ' + f2(g.y + 1.3) + ')' });
      });
      // brillo final
      var gl = ph === 2 ? prog(u, .05, .55) : 0;
      set(glint, { opacity: f2(gl > 0 && gl < 1 ? 1 : 0), 'stroke-dashoffset': f2(.1 - gl * 1.25) });
      sparks.forEach(function (s, i) {
        var k = ph === 2 ? prog(u, .12 + i * .09, .32 + i * .09) : 0, sc = Math.sin(k * PI) * s.s;
        set(s.g, { transform: 'translate(' + f2(s.x) + ' ' + f2(s.y) + ') scale(' + f2(sc) + ') rotate(' + f2(k * 40) + ')' });
      });
      if (ph !== curPh) {
        curPh = ph;
        steps.forEach(function (b, i) { b.classList.toggle('is-on', i === ph); b.classList.toggle('is-done', i < ph); });
        if (mini) fade(mc, MINI[ph]);
        else { cap.style.opacity = 0; setTimeout(function () { cap.innerHTML = CAPS[ph]; cap.style.opacity = 1; }, 180); }
      }
      if (rail) rail.style.transform = 'scaleX(' + (tt / TOTAL).toFixed(4) + ')';
      if (mini) fillSegs(root, DUR, tt);
    }
    return {
      root: root,
      start: function (now) { t0 = now; last = now; },
      tick: function (now) {
        last = now;
        if (jumpTo != null) { t0 = now - (jumpTo === 0 ? 0 : jumpTo === 1 ? DUR[0] : DUR[0] + DUR[1]) * 1000; jumpTo = null; }
        var tt = (now - t0) / 1000;
        if (tt >= TOTAL + .6) { t0 = now; tt = 0; firstLap = false; }
        at(Math.min(tt, TOTAL - .001));
      },
      still: function () { at(TOTAL - .001); },
      reset: function () { firstLap = true; }
    };
  }

  /* ====================================================================
     1b · LÍNEA DE TALLA UNIVERSAL (encima del botón de compra; no empuja el botón)
     ==================================================================== */
  function TallaLinea(root) {
    var target = root.getAttribute('data-target') || '';
    root.classList.add('cjc-line');
    root.innerHTML = '<span class="cjc-line-i"></span><span class="cjc-line-t"><strong>フリーサイズ</strong>・<wbr>手首に<wbr>合わせて<wbr>調整できます</span>' +
      (target ? '<a class="cjc-line-a" href="#' + target + '">調整方<wbr>法を<wbr>見る</a><wbr>' : '');
    var svg = S('svg', { viewBox: '0 0 34 26', 'aria-hidden': 'true' }, root.querySelector('.cjc-line-i'));
    var defs = S('defs', null, svg);
    var cuff = Cuff(svg, defs, COBRE, [1, 25]);
    var a = root.querySelector('.cjc-line-a');
    if (a) a.addEventListener('click', function (e) {
      var el = document.getElementById(target); if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
    });
    var t0 = 0;
    function draw(t) { cuff.update(17, 12.5, 11.2, 9.4, 3, (40 + 22 * t) * DEG); }
    return {
      root: root,
      start: function (now) { t0 = now; },
      tick: function (now) { var k = ((now - t0) / 1000) % 3.6; draw(ease(k < 1.8 ? k / 1.8 : 2 - k / 1.8)); },
      still: function () { draw(.5); }
    };
  }

  /* ---------- montaje ---------- */
  var MAKERS = { talla: Talla, 'talla-linea': TallaLinea, macizo: Macizo, patina: Patina };
  var live = [], running = false;
  function frame(now) {
    var any = false;
    for (var i = 0; i < live.length; i++) if (live[i].on) { live[i].c.tick(now); any = true; }
    running = any;
    if (any) requestAnimationFrame(frame);
  }
  function mountAll() {
    css();
    [].slice.call(document.querySelectorAll('[data-cj]:not([data-cj-on])')).forEach(function (el) {
      var mk = MAKERS[el.getAttribute('data-cj')];
      if (!mk) return;
      el.setAttribute('data-cj-on', '');
      var c = mk(el), rec = { c: c, on: false };
      if (REDUCE || !('IntersectionObserver' in window)) { c.still(); return; }
      c.still();
      live.push(rec);
      new IntersectionObserver(function (es) {
        var vis = es[0].isIntersecting;
        if (vis && !rec.on) { rec.on = true; c.start(performance.now()); if (!running) { running = true; requestAnimationFrame(frame); } }
        else if (!vis) rec.on = false;
      }, { threshold: .2 }).observe(el);
    });
  }
  window.cjConfianzaMount = mountAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
})();
